import React, { useState } from "react";
import { X } from "lucide-react";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";

const DESCRIPTION_MAX = 200;

/*
 * "Create New Role" modal — collects only Role Name + Description. It does
 * not create the role itself; the caller navigates to the Permission
 * Configuration page (CREATE mode) on success, where the role is actually
 * created together with its permissions on Save. Editing an existing role's
 * name/description happens on that same Permission Configuration page too —
 * there's no separate "Edit Role" modal anymore.
 */
const RoleFormModal = ({ onCancel, onSubmit, isSubmitting }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Role name is required.");
      return;
    }
    setError("");
    const result = await onSubmit({ name: name.trim(), description: description.trim() });
    if (result?.error) setError(result.error);
  };

  return (
    <div className="rm-modal-overlay" onClick={onCancel}>
      <div className="rm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="rm-modal-header">
          <div>
            <h2 className="rm-modal-title">Create New Role</h2>
            <p className="rm-modal-subtitle">Enter role details to create a new role.</p>
          </div>
          <button type="button" className="rm-modal-close" onClick={onCancel} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="rm-form-field">
            <label htmlFor="role-name">Role Name *</label>
            <input
              id="role-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter role name"
              autoFocus
            />
            <span className="rm-form-hint">Must be unique</span>
          </div>

          <div className="rm-form-field">
            <label htmlFor="role-description">Description (Optional)</label>
            <textarea
              id="role-description"
              value={description}
              maxLength={DESCRIPTION_MAX}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter role description"
              rows={3}
            />
            <span className="rm-form-hint rm-form-hint-right">
              {description.length}/{DESCRIPTION_MAX}
            </span>
          </div>

          {error && <p className="rm-form-error">{error}</p>}

          <div className="rm-modal-actions">
            <SecondaryButton type="button" onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </SecondaryButton>
            <PrimaryButton type="submit" width="140px" disabled={isSubmitting}>
              {isSubmitting ? "Saving..." : "Create Role"}
            </PrimaryButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RoleFormModal;
